"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FakeEventsClient = void 0;
class FakeEventsClient {
    constructor() {
        this.events = [];
    }
    trackPageRendered(request) {
        this.events.push(request);
        return Promise.resolve();
    }
    trackSearchQueryCompletionsSuggested(request) {
        this.events.push(request);
        return Promise.resolve();
    }
    trackCollectionInteraction(_, request, _referer) {
        this.events.push(request);
        return Promise.resolve();
    }
    trackUserExpired() {
        this.events.push({ type: 'USER_EXPIRED' });
        return Promise.resolve();
    }
    trackPlatformInteraction(subtype, anonymous) {
        const event = {
            type: 'PLATFORM_INTERACTED_WITH',
            subtype,
            anonymous,
        };
        this.events.push(event);
        return Promise.resolve();
    }
    trackVideoInteraction(_video, subtype) {
        const event = {
            type: 'VIDEO_INTERACTED_WITH',
            subtype,
        };
        this.events.push(event);
        return Promise.resolve();
    }
    clear() {
        this.events = [];
    }
    getEvents() {
        return this.events;
    }
}
exports.FakeEventsClient = FakeEventsClient;
//# sourceMappingURL=FakeEventsClient.js.map